import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-search-outline',
    templateUrl: './search-outline.component.html',
    styleUrls: ['./search-outline.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class SearchOutlineComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    searchInput: FormControl;

    @Input()
    label: string = '';

    constructor() {
        super();
    }

    ngOnInit(): void {
        if (!this.searchInput) {
            return;
        }

        // Strip leading spaces while typing/pasting so searches don't run with a leading space.
        // Keep trailing spaces so users can type multi-word terms (e.g. "First Last").
        this.searchInput.valueChanges.pipe(debounceTime(200), takeUntil(this._unsubscribeAll)).subscribe(() => {
            this.stripLeadingSpaces();
        });
    }

    stripLeadingSpaces(): void {
        if (!this.searchInput) {
            return;
        }

        const value = this.searchInput.value;
        if (typeof value !== 'string') {
            return;
        }

        const withoutLeading = value.replace(/^\s+/, '');
        if (value !== withoutLeading) {
            this.searchInput.setValue(withoutLeading);
        }
    }

    /**
     * Full trim when the user finishes editing (blur/Enter).
     * Trailing spaces from paste are cleaned here without blocking mid-typing spaces.
     */
    trimSearchValue(): void {
        if (!this.searchInput) {
            return;
        }

        const value = this.searchInput.value;
        if (typeof value !== 'string') {
            return;
        }

        const trimmed = value.trim();
        if (value !== trimmed) {
            this.searchInput.setValue(trimmed);
        }
    }
}
